<template>
  <div class="small gray-1-color">
    {{ ORDER_LOOKUP.checkStatusForm.continueAgreeLabel }} {{ brandName }}
    <a target="_blank" :href="privacyLink" rel="noopener" class="gray-1-color">
      {{ ORDER_LOOKUP.checkStatusForm.privacyPracticesLabel }}
    </a>
  </div>
</template>

<script setup>
import { brandName, privacyLink, ORDER_LOOKUP } from 'config';
</script>
